import React, { Component } from 'react';
import { Row, Col, Button, Spinner, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faCheckCircle, faCheckDouble, faChevronDown, faChevronUp, faEnvelopeOpenText, faFileArrowDown, faFileInvoiceDollar, faFlag, faNoteSticky, faPencil, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { connect } from 'react-redux';
import { t } from '../../helpers/translation_helper';
import { GET, POST } from '../../api';
import { toast } from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

class LeadCard extends Component {

  deleteConfirm = {
    show: false,
    id: 0,
    action: () => { }
  }

  state = {
    collapsed: true,
    deleted: false,
    admissionApproveAlert: false,
    movingProfile: false,
    leadObject: {},
    deleteConfirm: this.deleteConfirm,
  }

  componentDidMount() {
    this.setState({
      leadObject: this.props.leadObject
    });
  }

  delete = async () => {
    try {
      const res = await GET('waiting/delete', {
        params: {
          waiting_id: this.state.deleteConfirm.id,
        },
      });


      if (res.data.type) {
        this.setState({
          deleted: true,
          deleteConfirm: this.deleteConfirm,
        });
        toast.success(t(res.data.message));
      } else {
        toast.error(t(res.data.message));
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  };

  moveProfile = async () => {
    const { leadObject } = this.state;

    this.setState({
      movingProfile: true,
      admissionApproveAlert: false,
    });

    try {
      const fData = new FormData();
      fData.append('admission_id', leadObject.admission_id);
      const res = await POST('waiting/move-profiles', fData);

      if (res) {
        let resData = res.data;
        if (resData.type) {
          leadObject.admission_status = 7;
          this.setState({
            leadObject,
            movingProfile: false,
          });
        } else {
          this.setState({
            movingProfile: false,
          });
        }
        toast[resData.messageType](t(resData.message));
      }
    } catch (err) {
      this.setState({
        movingProfile: false,
      });
      console.log(err);
      toast.error(t('Something went wrong!'));
      return;
    }
  };

  actionButtons = () => {

    const { leadObject } = this.state;
    const { edit, handleOpenTasksModal, handleOpenNotesModal, handleOpenFormUrlModal, handleOpenAdmissionFormModal, handleOpenPaymentUrlModal, downloadAdmissionForm } = this.props;
    if (!leadObject.waitingtasks) {
      return null
    }
    const commonButtons = (
      <>
        <Button
          style={{ width: 60 }}
          title='Tasks'
          onClick={() => handleOpenTasksModal(leadObject)}
          variant='success'
          size='sm'
          className='me-2'>
          <FontAwesomeIcon icon={faFlag} />
        </Button>
      </>
    );

    const notesButton = (
      <Button
        style={{ width: 60 }}
        title='Notes'
        onClick={() => handleOpenNotesModal(leadObject)}
        variant='warning'
        size='sm'
        className='me-2'>
        <FontAwesomeIcon icon={faNoteSticky} />
      </Button>
    );

    let admission_status_6_7_8 = leadObject.waitingtasks.filter((v) => [6, 7, 8].includes(v.admission_status_id))
    let admission_status_6_8 = leadObject.waitingtasks.filter((v) => [6, 8].includes(v.admission_status_id))

    const canDelete = !leadObject.admission_id || admission_status_6_7_8.length <= 0
    // (leadObject.admission_status !== 6 &&
    //   leadObject.admission_status !== 7 &&
    //   leadObject.admission_status !== 8);

    const deleteButton = canDelete ? (
      <Button
        style={{ width: 60 }}
        title='Delete'
        onClick={() => this.setState({
          deleteConfirm: {
            show: true,
            id: leadObject.waiting_id,
            action: this.delete,
          }
        })}
        variant='danger'
        size='sm'
        className='me-2'>
        <FontAwesomeIcon icon={faTrash} />
      </Button>
    ) : null;

    if (!leadObject.admission_id) {
      return (
        <>
          {commonButtons}
          {deleteButton}
          <Button
            style={{ width: 60 }}
            title='Edit'
            onClick={() => edit(leadObject)}
            variant='warning'
            size='sm'
            className='me-2'>
            <FontAwesomeIcon icon={faPencil} />
          </Button>
          {notesButton}
        </>
      );
    } else {
      // const isProcessingAdmission = ![6, 7, 8].includes(leadObject.admission_status);
      // console.log('admission_status_6_8', admission_status_6_8)
      const isProcessingAdmission = (admission_status_6_8.length <= 0)

      const approveAdmissionBtn = isProcessingAdmission && !leadObject.parent_id && (
        <>
          <Button
            style={{ width: 60 }}
            title='Approve Admission'
            onClick={() =>
              this.setState({
                admissionApproveAlert: true,
              })
            }
            variant='danger'
            size='sm'
            className='me-2'>
            <FontAwesomeIcon color='#fff' icon={faCheckDouble} />
          </Button>
          {notesButton}
        </>
      );

      const admissionButtons = (
        <>
          <Button
            style={{ width: 60 }}
            title='Send Form URL to Parent'
            onClick={() => handleOpenFormUrlModal(leadObject.admission_id)}
            variant='outline-info'
            size='sm'
            className='me-2'>
            <FontAwesomeIcon icon={faEnvelopeOpenText} />
          </Button>
          <Button
            style={{ width: 60 }}
            onClick={() => handleOpenAdmissionFormModal(leadObject.admission_id)}
            title='Open Admission Form'
            variant='outline-info'
            size='sm'
            className='me-2'>
            <FontAwesomeIcon icon={faBoxOpen} />
          </Button>
          <Button
            style={{ width: 60 }}
            onClick={() => handleOpenPaymentUrlModal(leadObject.admission_id)}
            title='Send Payment URL to Parent'
            variant='outline-info'
            size='sm'
            className='me-2'>
            <FontAwesomeIcon icon={faFileInvoiceDollar} />
          </Button>
          <Button
            style={{ width: 60 }}
            title='Download'
            onClick={() => downloadAdmissionForm(leadObject.admission_id)}
            variant='outline-info'
            size='sm'
            className='me-2'>
            <FontAwesomeIcon icon={faFileArrowDown} />
          </Button>
        </>
      );

      return <>
        {commonButtons}
        {deleteButton}
        {admissionButtons}
        {approveAdmissionBtn}
        {this.state.movingProfile && (
          <Spinner animation='border' size='sm' className='ms-2' />
        )}
      </>;

    }
  }

  render() {
    const { leadIndex } = this.props;
    const { collapsed, leadObject, deleted } = this.state;

    if (deleted) {
      return null;
    }

    // let interested = '';
    // let interestedColor = '#000';
    // if (leadObject.interested == 'Y') {
    //   interested = 'Open';
    //   interestedColor = '#5BBD4A';
    // } else if (leadObject.interested == 'R') {
    //   interested = 'Registered';
    //   interestedColor = '#538DEE';
    // } else {
    //   interested = 'Lost';
    //   interestedColor = '#D13341';
    // }

    return (
      <div key={leadIndex} className='lead-card'>
        <div className='lead-card-header'>
          <button
            onClick={() => this.setState({ collapsed: !collapsed })}
            style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: '#fff',
              position: 'absolute',
              top: 10,
              right: 20,
              border: 0,
              boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.18)'
            }}>
            <FontAwesomeIcon icon={collapsed ? faChevronDown : faChevronUp} />
          </button>
          <div className='d-flex flex-row'>
            <div style={{ flex: 1 }} className='px-1'>
              <strong>{t('Student Name')}</strong><br />
              {leadObject.child_name || '-'}
            </div>
            <div style={{ flex: 1 }} className='px-1'>
              <strong>{t('Parent Name')}</strong><br />
              {leadObject.parent_name || '-'}
            </div>
            <div style={{ flex: 1 }} className='px-1'>
              <strong>{t('Phone')}</strong>
              <button
                onClick={() => {
                  if (leadObject.phone1) {
                    const phone = leadObject.phone1 + '';
                    if (phone.startsWith('+') || phone.startsWith('00')) {
                      let waNumber = phone.replace(/\D/g, '');
                      window.open(`https://wa.me/${waNumber}`, '_blank');
                    } else {
                      const country_id = this.props.authData.centerData.country_id;
                      let calligCode = '';

                      // We can get the calling code from countries table 
                      // along with the centerData on login
                      if (country_id == 2) {
                        calligCode = '971'; // UAE
                      } else if (country_id == 192) {
                        calligCode = '966'; // KSA
                      } else if (country_id == 126) {
                        calligCode = '961'; // Lebanon
                      }

                      let waNumber = calligCode + leadObject.phone1.replace(/\D/g, '');
                      window.open(`https://wa.me/${waNumber}`, '_blank');
                    }
                  }
                }}
                style={{ marginBottom: -20, position: 'relative', top: -3, border: 0, background: 'none' }}><img src={require('../../../src/assets/images/social-platforms/wa.png')} width={25} height={25} alt='WhatsApp' /></button><br />
              {leadObject.phone1 || '-'}
            </div>
            <div style={{ flex: 1 }} className='px-1'>
              <strong>{t('Email')}</strong>
              <button
                onClick={() => {
                  if (leadObject.email1) {
                    window.open(`mailto:${leadObject.email1}`, '_blank');
                  }
                }}
                style={{
                  marginLeft: 5,
                  marginTop: -8,
                  width: 25,
                  height: 25,
                  borderRadius: 25 / 2,
                  backgroundColor: '#4BCBF1',
                  position: 'relative',
                  border: 0,
                  color: '#fff',
                }}><FontAwesomeIcon icon={faEnvelope} /></button><br />
              <div className='d-flex flex-row flex-wrap'>
                {leadObject.email1 || '-'}
              </div>
            </div>
            <div style={{ flex: 1 }} className='px-1'>
              <strong>{t('Inquiry Date')}</strong><br />
              {moment(leadObject.waiting_date).format('DD-MM-YYYY') || '-'}
            </div>
          </div>
          <Row className='m-0'>


          </Row>
        </div>
        <div className='lead-card-body' style={{ display: collapsed ? 'none' : 'block' }}>
          <Row className='m-0'>
            <Col className='mb-3 px-1'>
              <strong>{t('Term')}</strong><br />
              {leadObject.term_name || '-'}
            </Col>
            <Col className='mb-3 px-1'>
              <strong>{t('DOB')}</strong><br />
              {moment(leadObject.child_birth).format('DD-MM-YYYY') || '-'}
            </Col>
            <Col className='mb-3 px-1'>
              <strong>{t('Nationality')}</strong><br />
              {leadObject.name_en || '-'}
            </Col>
            <Col className='mb-3 px-1'>
              <strong>{t('Operator')}</strong><br />
              {leadObject.employee_name || '-'}
            </Col>
            <Col className='mb-3 px-1'>
              <strong>{t('Expected Joining')}</strong><br />
              {moment(leadObject.joining_date).format('DD-MM-YYYY') || '-'}
            </Col>
          </Row>
          <Row className='m-0'>
            <Col className='mb-3 px-1'>
              <strong>{t('Source')}</strong><br />
              {leadObject.visitby_name || '-'}
            </Col>
            <Col className='mb-3 px-1'>
              <strong>{t('Referral')}</strong><br />
              {leadObject.referral_name || '-'}
            </Col>
            <Col className='mb-3 px-1'>
              <strong>{t('Previous School')}</strong><br />
              {leadObject.previous_nursery || '-'}
            </Col>
            <Col className='mb-3 px-1'></Col>
            <Col className='mb-3 px-1'></Col>
          </Row>
          <Row className='m-0'>
            <Col md={12} className='mb-3 px-1'>
              <strong>{t('Joining Notes')}</strong><br />
              {leadObject.joining_note || '-'}
            </Col>
            <Col md={6} className='mb-3 px-1'>
              <strong>{t('No Enroll Reason')}</strong><br />
              {leadObject.noenrolment_name || '-'}
            </Col>
            <Col md={12} className='mb-3 px-1'>
              <strong>{t('Reason Explanation')}</strong><br />
              {leadObject.no_reg_reason || '-'}
            </Col>
          </Row>
        </div>
        <div className='lead-card-footer' style={{ padding: '5px 12px' }}>
          {leadObject.last_task &&
            <div style={{
              backgroundColor: '#FEFAEA',
              border: '#FCE9A3 2px solid',
              borderRadius: 5,
              padding: '5px 10px',
              marginBottom: 12
            }}>
              <strong>{t('Last Task:')} </strong> {leadObject.last_task}
            </div>
          }
          <Row className='m-0'>
            <Col md={8} className='ps-0'>
              {this.actionButtons()}
            </Col>
            <Col md={4} className='text-end pe-0'>
              {(leadObject.waitingtasks && leadObject.waitingtasks.find((v) => [6, 8].includes(v.admission_status_id))) &&
                // {[6, 7, 8].includes(leadObject.admission_status) &&
                <span
                  title={t('Application Approved or Rejected')}
                  style={{
                    width: 60,
                    border: `#48CF48 2px solid`,
                    borderRadius: 5,
                    display: 'inline-block',
                    padding: '2px 5px',
                    fontSize: 14,
                    height: 30,
                    color: '#48CF48',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    marginRight: 10
                  }}><FontAwesomeIcon icon={faCheckCircle} /></span>
              }
              {/* <span style={{
                border: `${interestedColor} 2px solid`,
                borderRadius: 5,
                display: 'inline-block',
                padding: '2px 5px',
                fontSize: 14,
                height: 30,
                color: interestedColor,
                fontWeight: 'bold',
              }}>{interested}</span> */}
              {leadObject.ls_abbreviation &&
                <span style={{
                  border: `${leadObject.ls_color} 2px solid`,
                  borderRadius: 5,
                  display: 'inline-block',
                  padding: '2px 5px',
                  fontSize: 14,
                  height: 30,
                  color: leadObject.ls_color,
                  fontWeight: 'bold',
                  marginLeft: 10
                }} title={(leadObject.waitingtasks) ? leadObject.waitingtasks.map((v) => v.ls_abbreviation).join(', ') : ''}>{leadObject.ls_abbreviation}</span>
              }
            </Col>
          </Row>
        </div>
        <SweetAlert
          show={this.state.admissionApproveAlert}
          warning
          showCancel
          confirmBtnText={t('Yes, Approve it!')}
          confirmBtnBsStyle='primary'
          title={t('Are you sure?')}
          onConfirm={this.moveProfile}
          onCancel={() =>
            this.setState({
              admissionApproveAlert: false,
            })
          }
          focusCancelBtn>
          {t(
            'you want to Approve this Admission and Add it to parents and Students Profiles! PS: Parent & Students should be unique'
          )}
        </SweetAlert>

        {/* Delete Confirmation */}
        <SweetAlert show={this.state.deleteConfirm.show} warning showCancel confirmBtnText={t('Yes, delete it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.deleteConfirm.action} onCancel={() => this.setState({ deleteConfirm: { show: false, id: 0, action: () => { } } })} focusCancelBtn>
          {t('Confirm Delete!')}
        </SweetAlert>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(LeadCard);